'use strict';

var SystemStatusHistoryController = function SystemStatusHistoryController($scope, systemConstants, dataRetrieverService, dataRetrieverConstantsService, ruleNavigationService) {
  $scope.visibleGrid = systemConstants.SCREEN_VALUE.SYSTEM_STATUS.HISTORY_MODE.MARKET;
  var dataRetrieverSystemStatusHistory = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_HISTORY_MODE);
  $scope.gridIdToDomain = {
    'system-status-history-market': 'MarketDemand',
    'system-status-history-service': 'Service',
    'system-status-history-flight': 'Flight',
    'system-status-history-fares': 'Fares'
  };
  $scope.updateAdjustmentsHistoryDomain = function (gridId) {
    dataRetrieverSystemStatusHistory.updateAdditionalParameters({
      adjustmentsHistoryDomain: $scope.gridIdToDomain[gridId]
    });
  };
  $scope.updateAdjustmentsHistoryDomain($scope.visibleGrid);
  $scope.switchGrid = function (gridId) {
    $scope.visibleGrid = gridId;
    $scope.updateAdjustmentsHistoryDomain(gridId);
  };
  $scope.gridVisible = function (gridId) {
    return $scope.visibleGrid === gridId;
  };
  $scope.$on('system-status:switch-history-grid', function (event, gridId) {
    $scope.switchGrid(gridId);
  });
  $scope.navigateToRules = function (technicalId) {
    ruleNavigationService.navigateToRules(technicalId);
  };
};
SystemStatusHistoryController.$inject = ['$scope', 'SystemConstants', 'DataRetrieverService', 'DataRetrieverConstantsService', 'RuleNavigationService'];
module.exports = SystemStatusHistoryController;